<template>
  <div class="content">
    <PageHeader :title="$t('template-component.header')" />
    <router-link
      :to="`/mail/templates`"
      class="btn btn-secundary right"
      style="position: absolute; right: 30px; top: 35px"
      ><i class="fas fa-arrow-left"></i>
      {{ $t('generic-str.return') }}</router-link
    >
    <div class="page-content container-fluid">
      <div class="card card-tabs">
        <div class="card-header">
          <ul class="nav nav-tabs primary-tabs" style="margin-bottom: 0px">
            <li class="nav-item nav-m-custom" role="presentation">
              <a
                href="javascript:void(0)"
                class="nav-link active"
                v-tab="'simple'"
                data-toggle="tab"
                aria-expanded="true"
                @click="changeType('simple')"
                >Editor</a
              >
            </li>
            <li class="nav-item nav-m-custom" role="presentation"></li>
          </ul>
          <ul class="actions top-right">
            <li>
              <a
                v-tooltip.top="'Escolher Modelo'"
                v-modal="{
                  target: 'libary-modal',
                  data: {
                    isLib: true,
                  },
                }"
                href="javascript:void(0)"
                class="btn btn-primary btn-floating to-right"
                ><i class="fas fa-edit text-white"></i
              ></a>
            </li>
            <li>
              <a
                v-tooltip.top="'Habilitar Editor de Código'"
                href="javascript:void(0)"
                id="codeEditorButtonId"
                class="btn btn-secondary btn-floating to-right"
                ><i class="fas fa-code text-white"></i
              ></a>
            </li>
            <li>
              <a
                v-tooltip.top="'Copiar template'"
                href="javascript:void(0)"
                @click="copyTemplate"
                v-if="
                  this.$route.params.id && this.$route.params.isLib == 'false'
                "
                class="btn btn-info btn-floating to-right"
                ><i class="fas fa-copy text-white"></i
              ></a>
            </li>
            <li>
              <a
                v-tooltip.top="'Apagar Template'"
                id="deleteTemplate"
                @click="remove()"
                class="btn btn-danger btn-floating to-right"
                ><i class="fas fa-trash text-white"></i
              ></a>
            </li>
          </ul>
        </div>
        <div class="card-body" style="padding: 0">
          <div class="form-body">
            <section class="copy">
              <div style="margin-left: 10px; width: 300px">
                <div class="input-group">
                  <div class="input-group-append">
                    <div class="unsubscribe-t">Preview:</div>
                  </div>
                  <input
                    id="previewInput"
                    type="text"
                    class="form-control"
                    value="https://%preview%"
                    readonly
                    style="width: 30px"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-secondary"
                      type="button"
                      ref="previewCopy"
                      value="previewCopy"
                      @click="copyData(1)"
                    >
                      {{ $t('generic-str.copy') }}
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <div class="input-group">
                  <div class="input-group-append">
                    <div class="unsubscribe-t">Link descadastramento:</div>
                  </div>
                  <input
                    id="unsubInput"
                    type="text"
                    class="form-control"
                    value="https://%unsubscribe%"
                    readonly
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-secondary"
                      type="button"
                      ref="unsubCopy"
                      value="unsubCopy"
                      @click="copyData(0)"
                    >
                      {{ $t('generic-str.copy') }}
                    </button>
                  </div>
                </div>
              </div>
            </section>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="tab-content">
                  <div
                    class="tab-pane active"
                    id="simple"
                    style="min-height: 710px"
                  >
                    <div class="live-load" v-if="isLoading">
                      <b-spinner
                        variant="primary"
                        type="grow"
                        small
                      ></b-spinner>
                      <b-spinner
                        variant="primary"
                        type="grow"
                        small
                      ></b-spinner>
                      <b-spinner
                        variant="primary"
                        type="grow"
                        small
                      ></b-spinner>
                    </div>
                    <div
                      :class="{
                        show: isLoading === false,
                        hide: isLoading === true,
                      }"
                    >
                      <div id="stripoSettingsContainer"></div>
                      <div id="stripoPreviewContainer"></div>
                    </div>
                  </div>
                  <div class="tab-pane" id="code" style="padding: 20px">
                    <div>
                      <email-input v-model="form.body" :variables="vars" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-lg-12"
                style="padding: 20px; padding-left: 40px; padding-right: 40px"
              >
                <hr />
                <div class="form-group">
                  <label>{{ $tc('generic-str.name', 1) }}</label>
                  <input
                    v-model="form.name"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="row" v-if="libCheck">
                  <div class="col-sm-12"><hr /></div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Biblioteca </label>
                    </div>
                    <div class="form-group">
                      <toggle-button
                        v-model="isLib"
                        class="mt5"
                        :sync="false"
                        :value="isLib"
                        @change="changeToggle()"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group" v-if="libCheck">
                  <div class="row">
                    <div class="col-sm-2">
                      <select class="form-control" v-model="form.type">
                        <option value="" selected>Tipo</option>
                        <option value="Assinatura">Assinatura</option>
                        <option value="Acompanhamento">Acompanhamento</option>
                        <option value="Alerta de evento">
                          Alerta de evento
                        </option>
                        <option value="Atualização de Produto">
                          Atualização de Produto
                        </option>
                        <option value="Acionar">Acionar</option>
                        <option value="Alertas e Notificações">
                          Alertas e Notificações
                        </option>
                        <option value="Bem vindo(a)">Bem vindo(a)</option>
                        <option value="Confirmação">Confirmação</option>
                        <option value="Carrinho abandonado">
                          Carrinho abandonado
                        </option>
                        <option value="Convite">Convite</option>
                        <option value="Confirmação">Confirmação</option>
                        <option value="E-mails de indicação">
                          E-mails de indicação
                        </option>
                        <option value="E-mails Frios">E-mails Frios</option>
                        <option value="Interativo">Interativo</option>
                        <option value="Interno">Interno</option>
                        <option value="Nova Coleção">Nova Coleção</option>
                        <option value="Desconto">Desconto</option>
                        <option value="Obrigado(a)">Obrigado(a)</option>
                        <option value="Pedido">Pedido</option>
                        <option value="Pedido de desculpas">
                          Pedido de desculpas
                        </option>
                        <option value="Pesquisa e Feedback">
                          Pesquisa e Feedback
                        </option>
                        <option value="Pós-venda">Pós-venda</option>
                        <option value="Promoção">Promoção</option>
                        <option value="Redefinição de senha">
                          Redefinição de senha
                        </option>
                        <option value="Resumo de E-mail">
                          Resumo de E-mail
                        </option>
                        <option value="Retargeting">Retargeting</option>
                        <option value="Retenção e Reativação">
                          Retenção e Reativação
                        </option>
                        <option value="Eventos">Eventos</option>
                        <option value="Testes">Testes</option>
                        <option value="Transacional">Transacional</option>
                        <option value="Ecommerce">Ecommerce</option>
                        <option value="Festas">Festas</option>
                        <option value="Newsletter">Newsletter</option>
                        <option value="Promoções">Promoções</option>
                        <option value="Vendas">Vendas</option>
                        <option value="Outros">Outros</option>
                      </select>
                    </div>
                    <div class="col-sm-2">
                      <select class="form-control" v-model="form.station">
                        <option value="" selected>Estação</option>
                        <option value="Aniversário">Aniversário</option>
                        <option value="Ação de Graças">Ação de Graças</option>
                        <option value="Ano Novo">Ano Novo</option>
                        <option value="Ano Novo Chinês">Ano Novo Chinês</option>
                        <option value="Cinco de Mayo">Cinco de Mayo</option>
                        <option value="Convite de casamento">
                          Convite de casamento
                        </option>
                        <option value="Cyber Monday">Cyber Monday</option>
                        <option value="Dia ANZAC">Dia ANZAC</option>
                        <option value="Dia da Austrália">
                          Dia da Austrália
                        </option>
                        <option value="Dia da Bastilha">Dia da Bastilha</option>
                        <option value="Dia da Igualdade Feminina">
                          Dia da Igualdade Feminina
                        </option>
                        <option value="Dia da Independência">
                          Dia da Independência
                        </option>
                        <option value="Dia da Mentira">Dia da Mentira</option>
                        <option value="Dia da Unidade Alemã">
                          Dia da Unidade Alemã
                        </option>
                        <option value="Dia de São Patrício">
                          Dia de São Patrício
                        </option>
                        <option value="Dia do Buda">Dia do Buda</option>
                        <option value="Dia do Presidente">
                          Dia do Presidente
                        </option>
                        <option value="Dia do videogame">
                          Dia do videogame
                        </option>
                        <option value="Dia dos Amantes do Livro">
                          Dia dos Amantes do Livro
                        </option>
                        <option value="Dia dos Mortos">Dia dos Mortos</option>
                        <option value="Dia dos Namorados">
                          Dia dos Namorados
                        </option>
                        <option value="Dia Internacional da Enfermeira">
                          Dia Internacional da Enfermeira
                        </option>
                        <option value="Dia Internacional da Mulher">
                          Dia Internacional da Mulher
                        </option>
                        <option value="Dia Internacional das Famílias">
                          Dia Internacional das Famílias
                        </option>
                        <option value="Dia Internacional do Chocolate">
                          Dia Internacional do Chocolate
                        </option>
                        <option value="Dia internacional do programador">
                          Dia internacional do programador
                        </option>
                        <option value="Dia Internacional dos Homens">
                          Dia Internacional dos Homens
                        </option>
                        <option value="Dia Mundial do Meio Ambiente">
                          Dia Mundial do Meio Ambiente
                        </option>
                        <option value="Dia Mundial do Professor">
                          Dia Mundial do Professor
                        </option>
                        <option value="Dia Mundial do Turismo">
                          Dia Mundial do Turismo
                        </option>
                        <option value="Dia Mundial Vegano">
                          Dia Mundial Vegano
                        </option>
                        <option value="Diwali">Diwali</option>
                        <option value="Ferragosto">Ferragosto</option>
                        <option value="Festa do Sacrifício">
                          Festa do Sacrifício
                        </option>
                        <option value="Festival Global de Compras">
                          Festival Global de Compras
                        </option>
                        <option value="Hanukkah">Hanukkah</option>
                        <option value="Hora Terrestre">Hora Terrestre</option>
                        <option value="Horário de verão">
                          Horário de verão
                        </option>
                        <option value="Mardi Gras">Mardi Gras</option>
                        <option value="Memorial Day">Memorial Day</option>
                        <option value="Mês da História Negra">
                          Mês da História Negra
                        </option>
                        <option
                          value="Mês de Conscientização ao Câncer de Mama"
                        >
                          Mês de Conscientização ao Câncer de Mama
                        </option>
                        <option value="Mês do Orgulho LGBTQ">
                          Mês do Orgulho LGBTQ
                        </option>
                        <option value="Octoberfest">Octoberfest</option>
                        <option value="Primeiro dia do outono">
                          Primeiro dia do outono
                        </option>
                        <option value="Purim">Purim</option>
                        <option value="Segunda-feira de carnaval">
                          Segunda-feira de carnaval
                        </option>
                        <option value="Semana da moda">Semana da moda</option>
                        <option value="Sexta-feira 13">Sexta-feira 13</option>
                        <option value="Small Business Saturday">
                          Small Business Saturday
                        </option>
                        <option value="Super Bowl">Super Bowl</option>
                        <option value="Terça solidária">Terça solidária</option>
                        <option value="Volta às Aulas">Volta às Aulas</option>
                        <option value="Waitangi Day">Waitangi Day</option>
                        <option value="Black Friday">Black Friday</option>
                        <option value="Dia das mães">Dia das mães</option>
                        <option value="Dia da Terra">Dia da Terra</option>
                        <option value="Dia do Trabalho">Dia do Trabalho</option>
                        <option value="Dia dos pais">Dia dos pais</option>
                        <option value="Moda">Moda</option>
                        <option value="Natal">Natal</option>
                        <option value="Páscoa">Páscoa</option>
                        <option value="Primavera">Primavera</option>
                        <option value="Halloween">Halloween</option>
                        <option value="Inverno">Inverno</option>
                        <option value="Outros">Outros</option>
                      </select>
                    </div>
                    <div class="col-sm-2">
                      <select class="form-control" v-model="form.resource">
                        <option value="" selected>Recurso</option>
                        <option value="AMP">AMP</option>
                        <option value="Animação CSS">Animação CSS</option>
                        <option value="Carousel">Carousel</option>
                        <option value="Cronômetro decrescente">
                          Cronômetro decrescente
                        </option>
                        <option value="Elementos inteligentes">
                          Elementos inteligentes
                        </option>
                        <option value="Ludificação">Ludificação</option>
                        <option value="Menu Sanfona">Vídeo</option>
                        <option value="Rolagem de Imagens">Vídeo</option>
                        <option value="Tipografia">Tipografia</option>
                        <option value="Carousel">Carousel</option>
                        <option value="Outros">Outros</option>
                      </select>
                    </div>
                    <div class="col-sm-2">
                      <select class="form-control" v-model="form.industry">
                        <option value="" selected>Indústria</option>
                        <option value="Arte">Arte</option>
                        <option value="Animais de Estimação">
                          Animais de Estimação
                        </option>
                        <option value="Beleza e Cuidados Pessoais">
                          Beleza e Cuidados Pessoais
                        </option>
                        <option value="Caridade">Caridade</option>
                        <option value="Casa e Jardim">Casa e Jardim</option>
                        <option value="Cinema e Música">Cinema e Música</option>
                        <option value="Construção">Construção</option>
                        <option value="Consultoria">Consultoria</option>
                        <option value="Cuidados de saúde">
                          Cuidados de saúde
                        </option>
                        <option value="Design">Design</option>
                        <option value="Educação">Educação</option>
                        <option value="Eletrônicos">Eletrônicos</option>
                        <option value="Entretenimento">Entretenimento</option>
                        <option value="Esporte e Preparo físico">
                          Esporte e Preparo físico
                        </option>
                        <option value="Finanças">Finanças</option>
                        <option value="Fotografia">Fotografia</option>
                        <option value="Gadgets">Gadgets</option>
                        <option value="Hobbies">Hobbies</option>
                        <option value="Hotéis">Hotéis</option>
                        <option value="Imóveis">Imóveis</option>
                        <option value="Jogos">Jogos</option>
                        <option value="Joias">Joias</option>
                        <option value="Jurídico">Jurídico</option>
                        <option value="Linhas Aéreas">Linhas Aéreas</option>
                        <option value="Livros, Presentes e Papelaria">
                          Livros, Presentes e Papelaria
                        </option>
                        <option value="Moda">Moda</option>
                        <option value="Logística e Entrega">
                          Logística e Entrega
                        </option>
                        <option value="Móveis, Interior e Faça-Você-Mesmo">
                          Móveis, Interior e Faça-Você-Mesmo
                        </option>
                        <option value="Negócios">Negócios</option>
                        <option value="Presentes e Artesanatos">
                          Presentes e Artesanatos
                        </option>
                        <option value="Produtos Infantis">
                          Produtos Infantis
                        </option>
                        <option value="Produtos Orgânicos e Ecológicos">
                          Produtos Orgânicos e Ecológicos
                        </option>
                        <option value="Publicações e Blogging">
                          Publicações e Blogging
                        </option>
                        <option value="Restaurantes">Restaurantes</option>
                        <option value="Saúde e bem-estar">
                          Saúde e bem-estar
                        </option>
                        <option value="Seguros">Seguros</option>
                        <option value="Sem fins lucrativos">
                          Sem fins lucrativos
                        </option>
                        <option value="Webinars">Webinars</option>
                        <option value="Auto e Moto">Auto e Moto</option>
                        <option value="Software e Tecnologia">
                          Software e Tecnologia
                        </option>
                        <option value="Bebida">Bebidas</option>
                        <option value="Comida">Comida</option>
                        <option value="Viagem e Turismo">
                          Viagem e Turismo
                        </option>
                        <option value="Outros">Outros</option>
                      </select>
                    </div>
                    <div class="col-md-12">
                      <hr />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer bg-light">
          <button
            class="btn btn-success"
            v-modal="{ target: 'preview-modal', data: form.body }"
            @click="mountPreview()"
          >
            <i class="fas fa-eye text-white"></i> Preview
          </button>
          <button
            id="msgSend"
            @click="save"
            type="button"
            :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }"
            :disabled="isSending || importing"
            class="btn btn-primary float-right"
          >
            {{ $t('generic-str.save') }}
          </button>
        </div>
      </div>
    </div>
    <create-contact-modal id="create-contact"></create-contact-modal>
    <create-group-modal id="create-group"></create-group-modal>
    <group-send-modal id="group-send-modal"></group-send-modal>
    <contact-send-modal id="contact-send-modal"></contact-send-modal>
    <preview-modal id="preview-modal"></preview-modal>
    <library-modal id="libary-modal" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '@/plugins/axios';
import axiosApi from 'axios';
import MailService from '@/services/mail.service';
import Tab from '@/directives/Tab';
import PageHeader from '@/components/PageHeader.vue';
import CreateContactModal from '@/components/contacts/CreateContactModal.vue';
import PreviewModal from '@/components/mails/PreviewModal.vue';
import GroupSendModal from '@/components/groups/GroupSendModal.vue';
import ContactSendModal from '@/components/contacts/ContactSendModal.vue';
// import GroupTable from '@/components/groups/GroupTable.vue';
import CreateGroupModal from '@/components/groups/CreateGroupModal.vue';
import Swal from 'sweetalert2';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import TemplateInput from '@/components/mails/TemplateInput.vue';
import moment from 'moment';
import EmailInput from '@/components/form/EmailInput.vue';
import BucketService from '@/services/bucket.service';
import StripoApi from 'stripo.email';
import { ToggleButton } from 'vue-js-toggle-button';
import LibraryModal from '@/components/mails/LibraryModal.vue';

const grapesjs = require('grapesjs'); // can be replaced with the es6 import if a transpiler like babel is used
require('grapesjs/dist/css/grapes.min.css');
require('grapesjs-mjml');
require('grapesjs-preset-webpage');
require('grapesjs-preset-newsletter');

const BLANK_HTML = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><meta charset="UTF-8"><meta content="width=device-width, initial-scale=1" name="viewport"><meta name="x-apple-disable-message-reformatting"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta content="telephone=no" name="format-detection"><title></title><!--[if (mso 16)]>
    <style type="text/css">
    a {text-decoration: none;}
    </style>
    <![endif]--><!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]--><!--[if gte mso 9]>
<xml>
    <o:OfficeDocumentSettings>
    <o:AllowPNG></o:AllowPNG>
    <o:PixelsPerInch>96</o:PixelsPerInch>
    </o:OfficeDocumentSettings>
</xml>
<![endif]--></head><body><div class="es-wrapper-color"><!--[if gte mso 9]>
      <v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
        <v:fill type="tile" color="#f6f6f6"></v:fill>
      </v:background>
    <![endif]--><table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-email-paddings" valign="top"><table class="es-content es-preheader esd-header-popover" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td class="es-adaptive esd-stripe" align="center"><table class="es-content-body" width="600" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td class="esd-structure es-p10t es-p10b es-p20r es-p20l" align="left"><!--[if mso]><table width="560"><tr><td width="268" valign="top"><![endif]--><table class="es-left" cellspacing="0" cellpadding="0" align="left"><tbody><tr><td class="esd-container-frame" width="268" align="left"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="es-infoblock esd-block-text es-m-txt-c" align="left"><p>Put your preheader text here</p></td></tr></tbody></table></td></tr></tbody></table><!--[if mso]></td><td width="20"></td><td width="272" valign="top"><![endif]--><table class="es-right" cellspacing="0" cellpadding="0" align="right"><tbody><tr><td class="esd-container-frame" width="272" align="left"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="es-infoblock esd-block-text es-m-txt-c" align="right"><p><a href="http://#" target="_blank">View in browser</a></p></td></tr></tbody></table></td></tr></tbody></table><!--[if mso]></td></tr></table><![endif]--></td></tr></tbody></table></td></tr></tbody></table><table class="es-content" cellspacing="0" cellpadding="0" align="center"><tbody><tr></tr><tr><td class="es-adaptive esd-stripe" align="center"><table class="es-header-body" width="600" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td class="esd-structure es-p15t es-p20b es-p20r es-p20l" style="background-color: #ffffff;" bgcolor="#ffffff" align="left"><!--[if mso]><table width="560" cellpadding="0" cellspacing="0"><tr><td width="174" valign="top"><![endif]--><table class="es-left" cellspacing="0" cellpadding="0" align="left"><tbody><tr><td class="es-m-p0r esd-container-frame" width="174" valign="top" align="center"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-block-image es-m-p0l es-m-txt-c" align="left" style="font-size:0"><a href="https://stripo.email/" target="_blank"><img src="https://hrn.stripocdn.email/content/guids/CABINET_003cfa7ac8b3f4c9da387f904d541e4f/images/37211522999250573.png" alt style="display: block;" width="118"></a></td></tr></tbody></table></td></tr></tbody></table><!--[if mso]></td><td width="20"></td><td width="366" valign="top"><![endif]--><table cellspacing="0" cellpadding="0" align="right"><tbody><tr><td class="esd-container-frame" width="366" align="left"><table style="border-left:2px solid #808080;border-right:2px solid #808080;border-top:2px solid #808080;border-bottom:2px solid #808080;" width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-block-menu" esd-img-prev-h="16" esd-img-prev-w="16"><table class="es-menu" width="100%" cellspacing="0" cellpadding="0"><tbody><tr class="links"><td class="es-p10t es-p10b es-p5r es-p5l " style="padding-bottom: 10px; padding-top: 10px; " width="25.00%" bgcolor="#f0f0f0" align="center"><a target="_blank" style="color: #333333;" href="https://stripo.email/">Service1</a></td><td class="es-p10t es-p10b es-p5r es-p5l " style="padding-bottom: 10px; padding-top: 10px; " width="25.00%" bgcolor="#f0f0f0" align="center"><a target="_blank" style="color: #333333;" href="https://stripo.email/">Service2</a></td><td class="es-p10t es-p10b es-p5r es-p5l " style="padding-bottom: 10px; padding-top: 10px; " width="25.00%" bgcolor="#f0f0f0" align="center"><a target="_blank" style="color: #333333;" href="https://stripo.email/">Service3</a></td><td class="es-p10t es-p10b es-p5r es-p5l " style="padding-bottom: 10px; padding-top: 10px; " width="25.00%" bgcolor="#f0f0f0" align="center"><a target="_blank" style="color: #333333;" href="https://stripo.email/">Service4</a></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><!--[if mso]></td></tr></table><![endif]--></td></tr></tbody></table></td></tr></tbody></table><table class="es-content" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td class="esd-stripe" align="center"><table class="es-content-body" width="600" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center"><tbody><tr><td class="esd-structure" align="left"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-container-frame" width="600" valign="top" align="center"><table style="border-left:2px solid #959595;border-right:2px solid #959595;border-top:2px solid #959595;border-bottom:2px solid #959595;" width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-block-image" align="center" style="font-size:0"><a target="_blank"><img class="adapt-img" src="https://hrn.stripocdn.email/content/guids/CABINET_e5244175dd1729a1d6ee1f8bd0d5490f/images/50421523966142571.jpg" alt style="display: block;" width="240"></a></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><table class="es-content" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td class="esd-stripe" align="center"><table class="es-content-body" width="600" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center"><tbody><tr><td class="esd-structure es-p30t es-p20r es-p20l" align="left"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-container-frame" width="560" valign="top" align="center"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-block-text es-p5b" align="left"><h2>TITLE HERE</h2></td></tr><tr><td class="esd-block-text es-m-txt-c es-p10b" align="left"><p style="color: #333333;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vitae interdum ligula. Pellentesque feugiat ligula ligula, in interdum dolor aliquet et. Aliquam vitae sem eget erat viverra malesuada.</p></td></tr><tr><td class="esd-block-text es-m-txt-c" align="left"><p style="color: #333333;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vitae interdum ligula. Pellentesque feugiat ligula ligula, in interdum dolor aliquet et. Aliquam vitae sem eget erat viverra malesuada.</p></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><table class="es-content" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td class="esd-stripe" align="center"><table class="es-content-body" width="600" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center"><tbody><tr><td class="esd-structure es-p20t es-p20r es-p20l" align="left"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-container-frame" width="560" valign="top" align="center"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-block-button es-p10b" align="left"><span class="es-button-border"><a href class="es-button" target="_blank"> Button </a></span></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><table class="es-content" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td class="esd-stripe" align="center"><table class="es-content-body" style="background-color: #ffffff;" width="600" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center"><tbody><tr><td class="esd-structure" align="left"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-container-frame" width="600" valign="top" align="center"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-block-spacer es-p40b es-p40r es-p40l" align="center" style="font-size:0"><table width="100%" height="100%" cellspacing="0" cellpadding="0" border="0"><tbody><tr><td style="border-bottom: 0px solid #efefef; background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%; height: 1px; width: 100%; margin: 0px;"></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td class="esd-structure es-p20t es-p20b es-p20r es-p20l" align="left"><!--[if mso]><table width="560" cellpadding="0"
                        cellspacing="0"><tr><td width="270" valign="top"><![endif]--><table class="es-left" cellspacing="0" cellpadding="0" align="left"><tbody><tr><td class="es-m-p20b esd-container-frame" width="270" align="left"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-block-text es-m-txt-c" align="left"><p style="color: #333333;">Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br></p></td></tr></tbody></table></td></tr></tbody></table><!--[if mso]></td><td width="20"></td><td width="270" valign="top"><![endif]--><table class="es-right" cellspacing="0" cellpadding="0" align="right"><tbody><tr><td class="esd-container-frame" width="270" align="left"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-block-social es-p5t es-m-txt-c" align="right" style="font-size:0"><table class="es-table-not-adapt es-social" cellspacing="0" cellpadding="0"><tbody><tr><td class="es-p10r" valign="top" align="center"><a target="_blank" href><img title="Facebook" src="https://hrn.stripocdn.email/content/assets/img/social-icons/logo-black/facebook-logo-black.png" alt="Fb" width="32"></a></td><td class="es-p10r" valign="top" align="center"><a target="_blank" href><img title="Twitter" src="https://hrn.stripocdn.email/content/assets/img/social-icons/logo-black/twitter-logo-black.png" alt="Tw" width="32"></a></td><td class="es-p10r" valign="top" align="center"><a target="_blank" href><img title="Instagram" src="https://hrn.stripocdn.email/content/assets/img/social-icons/logo-black/instagram-logo-black.png" alt="Inst" width="32"></a></td><td class="es-p10r" valign="top" align="center"><a target="_blank" href><img title="Youtube" src="https://hrn.stripocdn.email/content/assets/img/social-icons/logo-black/youtube-logo-black.png" alt="Yt" width="32"></a></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><!--[if mso]></td></tr></table><![endif]--></td></tr></tbody></table></td></tr></tbody></table><table class="es-footer" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td class="esd-stripe" align="center"><table class="es-footer-body" width="600" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td class="esd-structure es-p20t es-p20b es-p20r es-p20l" align="left"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-container-frame" width="560" valign="top" align="center"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-block-text" align="center"><p>Company Address</p><p>Pellentesque vitae interdum ligula. Pellentesque feugiat ligula ligula,</p><p>in interdum dolor aliquet et. Aliquam vitae sem eget erat viverra malesuada. Aliquam volutpat vel est quis euismod. Faucibus varius ex eget aliquam.</p></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><table class="esd-footer-popover es-content" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td class="esd-stripe" align="center"><table class="es-content-body" style="background-color: transparent;" width="600" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td class="esd-structure es-p30t es-p30b es-p20r es-p20l" align="left"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td class="esd-container-frame" width="560" valign="top" align="center"><table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td align="center" class="esd-empty-container" style="display: none;"></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></div></body></html>`;

const BLANK_CSS = `/* CONFIG STYLES Please do not delete and edit CSS styles below */
/* IMPORTANT THIS STYLES MUST BE ON FINAL EMAIL */
#outlook a {
  padding: 0;
}
.ExternalClass {
  width: 100%;
}
.ExternalClass,
.ExternalClass p,
.ExternalClass span,
.ExternalClass font,
.ExternalClass td,
.ExternalClass div {
  line-height: 100%;
}
.es-button {
  mso-style-priority: 100 !important;
  text-decoration: none !important;
}
a[x-apple-data-detectors] {
  color: inherit !important;
  text-decoration: none !important;
  font-size: inherit !important;
  font-family: inherit !important;
  font-weight: inherit !important;
  line-height: inherit !important;
}
.es-desk-hidden {
  display: none;
  float: left;
  overflow: hidden;
  width: 0;
  max-height: 0;
  line-height: 0;
  mso-hide: all;
}
[data-ogsb] .es-button {
  border-width: 0 !important;
  padding: 5px 30px 5px 30px !important;
}
/*
END OF IMPORTANT
*/
s {
  text-decoration: line-through;
}
html,
body {
  width: 100%;
  font-family: arial, 'helvetica neue', helvetica, sans-serif;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}
table {
  mso-table-lspace: 0pt;
  mso-table-rspace: 0pt;
  border-collapse: collapse;
  border-spacing: 0px;
}
table td,
html,
body,
.es-wrapper {
  padding: 0;
  Margin: 0;
}
.es-content,
.es-header,
.es-footer {
  table-layout: fixed !important;
  width: 100%;
}
img {
  display: block;
  border: 0;
  outline: none;
  text-decoration: none;
  -ms-interpolation-mode: bicubic;
}
table tr {
  border-collapse: collapse;
}
p,
hr {
  Margin: 0;
}
h1,
h2,
h3,
h4,
h5 {
  Margin: 0;
  line-height: 120%;
  mso-line-height-rule: exactly;
  font-family: arial, 'helvetica neue', helvetica, sans-serif;
}
p,
ul li,
ol li,
a {
  -webkit-text-size-adjust: none;
  -ms-text-size-adjust: none;
  mso-line-height-rule: exactly;
}
.es-left {
  float: left;
}
.es-right {
  float: right;
}
.es-p5 {
  padding: 5px;
}
.es-p5t {
  padding-top: 5px;
}
.es-p5b {
  padding-bottom: 5px;
}
.es-p5l {
  padding-left: 5px;
}
.es-p5r {
  padding-right: 5px;
}
.es-p10 {
  padding: 10px;
}
.es-p10t {
  padding-top: 10px;
}
.es-p10b {
  padding-bottom: 10px;
}
.es-p10l {
  padding-left: 10px;
}
.es-p10r {
  padding-right: 10px;
}
.es-p15 {
  padding: 15px;
}
.es-p15t {
  padding-top: 15px;
}
.es-p15b {
  padding-bottom: 15px;
}
.es-p15l {
  padding-left: 15px;
}
.es-p15r {
  padding-right: 15px;
}
.es-p20 {
  padding: 20px;
}
.es-p20t {
  padding-top: 20px;
}
.es-p20b {
  padding-bottom: 20px;
}
.es-p20l {
  padding-left: 20px;
}
.es-p20r {
  padding-right: 20px;
}
.es-p25 {
  padding: 25px;
}
.es-p25t {
  padding-top: 25px;
}
.es-p25b {
  padding-bottom: 25px;
}
.es-p25l {
  padding-left: 25px;
}
.es-p25r {
  padding-right: 25px;
}
.es-p30 {
  padding: 30px;
}
.es-p30t {
  padding-top: 30px;
}
.es-p30b {
  padding-bottom: 30px;
}
.es-p30l {
  padding-left: 30px;
}
.es-p30r {
  padding-right: 30px;
}
.es-p35 {
  padding: 35px;
}
.es-p35t {
  padding-top: 35px;
}
.es-p35b {
  padding-bottom: 35px;
}
.es-p35l {
  padding-left: 35px;
}
.es-p35r {
  padding-right: 35px;
}
.es-p40 {
  padding: 40px;
}
.es-p40t {
  padding-top: 40px;
}
.es-p40b {
  padding-bottom: 40px;
}
.es-p40l {
  padding-left: 40px;
}
.es-p40r {
  padding-right: 40px;
}
.es-menu td {
  border: 0;
}
.es-menu td a img {
  display: inline-block !important;
}
/* END CONFIG STYLES */
a {
  text-decoration: underline;
}
p,
ul li,
ol li {
  font-family: arial, 'helvetica neue', helvetica, sans-serif;
  line-height: 150%;
}
ul li,
ol li {
  Margin-bottom: 15px;
}
.es-menu td a {
  text-decoration: none;
  display: block;
  font-family: arial, 'helvetica neue', helvetica, sans-serif;
}
.es-wrapper {
  width: 100%;
  height: 100%;
  background-image: ;
  background-repeat: repeat;
  background-position: center top;
}
.es-wrapper-color {
  background-color: #f6f6f6;
}
.es-header {
  background-color: transparent;
  background-image: ;
  background-repeat: repeat;
  background-position: center top;
}
.es-header-body {
  background-color: transparent;
}
.es-header-body p,
.es-header-body ul li,
.es-header-body ol li {
  color: #333333;
  font-size: 14px;
}
.es-header-body a {
  color: #333333;
  font-size: 14px;
}
.es-content-body {
  background-color: #ffffff;
}
.es-content-body p,
.es-content-body ul li,
.es-content-body ol li {
  color: #333333;
  font-size: 14px;
}
.es-content-body a {
  color: #333333;
  font-size: 14px;
}
.es-footer {
  background-color: transparent;
  background-image: ;
  background-repeat: repeat;
  background-position: center top;
}
.es-footer-body {
  background-color: #808080;
}
.es-footer-body p,
.es-footer-body ul li,
.es-footer-body ol li {
  color: #ffffff;
  font-size: 14px;
}
.es-footer-body a {
  color: #ffffff;
  font-size: 14px;
}
.es-infoblock,
.es-infoblock p,
.es-infoblock ul li,
.es-infoblock ol li {
  line-height: 120%;
  font-size: 12px;
  color: #cccccc;
}
.es-infoblock a {
  font-size: 12px;
  color: #cccccc;
}
h1 {
  font-size: 30px;
  font-style: normal;
  font-weight: normal;
  color: #333333;
}
h2 {
  font-size: 24px;
  font-style: normal;
  font-weight: normal;
  color: #333333;
}
h3 {
  font-size: 20px;
  font-style: normal;
  font-weight: normal;
  color: #333333;
}
.es-header-body h1 a,.es-content-body h1 a,.es-footer-body h1 a {
  font-size: 30px;
}
.es-header-body h2 a,.es-content-body h2 a,.es-footer-body h2 a {
  font-size: 24px;
}
.es-header-body h3 a,.es-content-body h3 a,.es-footer-body h3 a {
  font-size: 20px;
}
a.es-button, button.es-button {
  border-style: solid;
  border-color: #f0f0f0;
  border-width: 5px 30px 5px 30px;
  display: inline-block;
  background: #f0f0f0;
  border-radius: 0px;
  font-size: 16px;
  font-family: arial, 'helvetica neue', helvetica, sans-serif;
  font-weight: normal;
  font-style: normal;
  line-height: 120%;
  color: #333333;
  text-decoration: none !important;
  width: auto;
  text-align: center;
}
.es-button-border {
  border-style: solid solid solid solid;
  border-color: #808080 #808080 #808080 #808080;
  background: #f0f0f0;
  border-width: 2px 2px 2px 2px;
  display: inline-block;
  border-radius: 0px;
  width: auto;
}
/* RESPONSIVE STYLES Please do not delete and edit CSS styles below. If you don't need responsive layout, please delete this section. */
@media only screen and (max-width: 600px) {
  p,
    ul li,
    ol li,
    a {
    line-height: 150% !important;
  }
  h1,h2,h3,h1 a,h2 a,h3 a {
    line-height: 120% !important;
  }
  h1 {
    font-size: 30px !important;
    text-align: center;
  }
  h2 {
    font-size: 26px !important;
    text-align: center;
  }
  h3 {
    font-size: 20px !important;
    text-align: center;
  }
  .es-header-body h1 a,.es-content-body h1 a,.es-footer-body h1 a {
    font-size: 30px !important;
  }
  .es-header-body h2 a,.es-content-body h2 a,.es-footer-body h2 a {
    font-size: 26px !important;
  }
  .es-header-body h3 a,.es-content-body h3 a,.es-footer-body h3 a {
    font-size: 20px !important;
  }
  .es-menu td a {
    font-size: 13px !important;
  }
  .es-header-body p,
    .es-header-body ul li,
    .es-header-body ol li,
    .es-header-body a {
    font-size: 16px !important;
  }
  .es-content-body p,.es-content-body ul li,.es-content-body ol li,.es-content-body a {
    font-size: 16px !important;
  }
  .es-footer-body p,
    .es-footer-body ul li,
    .es-footer-body ol li,
    .es-footer-body a {
    font-size: 16px !important;
  }
  .es-infoblock p,
    .es-infoblock ul li,
    .es-infoblock ol li,
    .es-infoblock a {
    font-size: 12px !important;
  }
  *[class="gmail-fix"] {
    display: none !important;
  }
  .es-m-txt-c,
    .es-m-txt-c h1,
    .es-m-txt-c h2,
    .es-m-txt-c h3 {
    text-align: center !important;
  }
  .es-m-txt-r,
    .es-m-txt-r h1,
    .es-m-txt-r h2,
    .es-m-txt-r h3 {
    text-align: right !important;
  }
  .es-m-txt-l,
    .es-m-txt-l h1,
    .es-m-txt-l h2,
    .es-m-txt-l h3 {
    text-align: left !important;
  }
  .es-m-txt-r img,
    .es-m-txt-c img,
    .es-m-txt-l img {
    display: inline !important;
  }
  .es-button-border {
    display: block !important;
  }
  a.es-button, button.es-button {
    font-size: 16px !important;
    display: block !important;
    border-left-width: 0px !important;
    border-right-width: 0px !important;
  }
  .es-btn-fw {
    border-width: 10px 0px !important;
    text-align: center !important;
  }
  .es-adaptive table,
    .es-btn-fw,
    .es-btn-fw-brdr,
    .es-left,
    .es-right {
    width: 100% !important;
  }
  .es-content table,
    .es-header table,
    .es-footer table,
    .es-content,
    .es-footer,
    .es-header {
    width: 100% !important;
    max-width: 600px !important;
  }
  .es-adapt-td {
    display: block !important;
    width: 100% !important;
  }
  .adapt-img {
    width: 100% !important;
    height: auto !important;
  }
  .es-m-p0 {
    padding: 0px !important;
  }
  .es-m-p0r {
    padding-right: 0px !important;
  }
  .es-m-p0l {
    padding-left: 0px !important;
  }
  .es-m-p0t {
    padding-top: 0px !important;
  }
  .es-m-p0b {
    padding-bottom: 0 !important;
  }
  .es-m-p20b {
    padding-bottom: 20px !important;
  }
  .es-mobile-hidden,
    .es-hidden {
    display: none !important;
  }
  tr.es-desk-hidden,
    td.es-desk-hidden,
    table.es-desk-hidden {
    display: table-row !important;
    width: auto !important;
    overflow: visible !important;
    float: none !important;
    max-height: inherit !important;
    line-height: inherit !important;
  }
  .es-desk-menu-hidden {
    display: table-cell !important;
  }
  table.es-table-not-adapt,
    .esd-block-html table {
    width: auto !important;
  }
  table.es-social {
    display: inline-block !important;
  }
  table.es-social td {
    display: inline-block !important;
  }
}
/* END RESPONSIVE STYLES */`;

export default {
  name: 'SendMail',
  components: {
    PageHeader,
    PreviewModal,
    CreateContactModal,
    ContactSendModal,
    GroupSendModal,
    CreateGroupModal,
    EmailInput,
    ToggleButton,
    LibraryModal,
  },
  directives: {
    Tab,
  },
  data() {
    return {
      isLib: false,
      libCheck: false,
      products: [],
      selectedProduct: {},
      isLoading: true,
      preview: false,
      domains: [],
      tags: [],
      file_name: null,
      shortCodes: [],
      addVars: false,
      addVarsSubject: false,
      hasVar: false,
      groups: [],
      isSending: false,
      contacts: [],
      files: [],
      dateOptions: {
        format: 'DD/MM/YYYY HH:mm',
        minDate: moment(),
        locale: 'pt',
        useCurrent: true,
        keepInvalid: true,
      },
      configEditor: {
        fullPage: true,
        allowedContent: true,
        extraPlugins: 'emoji',
      },
      selectedGroups: [],
      selectedContacts: [],
      selectedFiles: [],
      importing: false,
      uploadProgress: 0,
      vars: [],
      fileVariables: [],
      grape: {},
      form: {
        type: '',
        station: '',
        resource: '',
        industry: '',
        body: '',
      },
      unicode: false,
      replace: false,
      flash: false,
      segments: 1,
      submited: false,
      length: 0,
      stripoPlugin: {},
      typeCode: 'simple',
    };
  },
  computed: {
    classes() {
      return ['wizard'];
    },
    info() {
      return this.$store.state.account;
    },
  },
  created() {
    this.vars = [
      { name: this.$t('generic-str.lbl-first-name'), value: 'first_name' },
      { name: this.$t('generic-str.lbl-last-name'), value: 'last_name' },
      { name: this.$t('generic-str.lbl-cellphone'), value: 'mobile_number' },
      { name: 'Email', value: 'email' },
    ];
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
    }

    if (
      this.$store.state.account.id === '52867698-ac7b-4186-a7e9-8525161c8b7f'
    ) {
      this.libCheck = true;
    }

    this.$root.$on('template.changeModel', this.changeLib);
  },
  methods: {
    copyTemplate() {
      this.$router.push(
        `/mail/templates/create/${this.$route.params.id}/false/true`,
      );
    },
    copyData(e) {
      if (e === 1) {
        if (document.getElementById('previewInput').value.length) {
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: this.$t('template-component.link'),
            type: 'success',
          });
          console.log('Preview btn: ', document.getElementById('previewInput').value);
          this.$clipboard(document.getElementById('previewInput').value);
        } else {
          this.$toast.show({
            title: 'Erro',
            content: 'Link não encontrado',
            type: 'danger',
          });
        }
      } else if (e === 0) {
        if (document.getElementById('unsubInput').value.length) {
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: this.$t('template-component.link'),
            type: 'success',
          });
          console.log('Unsub btn: ', document.getElementById('unsubInput').value);
          this.$clipboard(document.getElementById('unsubInput').value);
        } else {
          this.$toast.show({
            title: 'Erro',
            content: 'Link não encontrado',
            type: 'danger',
          });
        }
      }
    },
    changeToggle() {
      this.$forceUpdate();
    },
    changeLib(lib) {
      this.isLoading = true;
      this.startPlugin(lib.html, lib.css);
    },
    getTemplate(page) {
      this.form.page = page;
      this.fetched = false;
      console.log(this.form);
      console.log(this.$route.params.isLib);
      if (this.$route.params.isLib === 'true') {
        MailService.getLibs({ id: this.$route.params.id }).then(
          (response) => {
            this.fetched = true;
            console.log(response);
            if (response.data[0]) {
              this.form = response.data[0];
              this.form.type = response.data[0].type
                ? response.data[0].type
                : '';
              this.form.station = response.data[0].station
                ? response.data[0].station
                : '';
              this.form.resource = response.data[0].resource
                ? response.data[0].resource
                : '';
              this.form.industry = response.data[0].industry
                ? response.data[0].industry
                : '';
              this.startPlugin(response.data[0].html, response.data[0].css);
            }
          },
          (error) => {
            this.content = error;
          },
        );
      } else {
        MailService.getTemplates({ id: this.$route.params.id }).then(
          (response) => {
            this.fetched = true;
            if (response[0]) {
              this.form = response[0];
              if (this.$route.params.isCopy === 'true') {
                delete this.form.id;
              }
              this.form.type = response[0].type
                ? response.data[0].type
                : '';
              this.form.station = response[0].station
                ? response.data[0].station
                : '';
              this.form.resource = response[0].resource
                ? response[0].resource
                : '';
              this.form.industry = response[0].industry
                ? response[0].industry
                : '';
              this.startPlugin(response[0].html, response[0].css);
            }
          },
          (error) => {
            this.content = error;
          },
        );
      }
    },
    save() {
      console.log(this.form);
      console.log(this.isLib);
      if (
        (this.$route.params.id === null ||
          this.$route.params.id === undefined) &&
        this.isLib === false
      ) {
        this.create();
        return;
      }

      if (this.$route.params.id && this.isLib === true) {
        this.editLib();
        return;
      }

      if (this.$route.params.id && this.$route.params.isCopy === 'true') {
        this.create();
        return;
      }

      if (
        this.$route.params.id &&
        this.$route.params.isLib === 'true' &&
        this.isLib === false
      ) {
        this.create();
        return;
      }

      if (this.isLib === true) {
        this.createLib();
        return;
      }

      if (
        this.$route.params.id &&
        (this.isLib === false ||
          this.isLib === undefined ||
          this.$route.params.isLib === 'false' ||
          this.$route.params.isCopy === 'false')
      ) {
        this.edit();
      }
    },
    edit() {
      this.isSending = true;
      if (this.typeCode === 'simple') {
        StripoApi.StripoApi.compileEmail((error, html, ampHtml, ampErrors) => {
          this.form.body = html;
          StripoApi.StripoApi.getTemplate((html, css) => {
            this.form.css = css;
            this.form.html = html;
            console.log(html);
            MailService.editTemplate(this.form).then(
              () => {
                this.$toast.show({
                  title: this.$t('generic-str.success'),
                  content: this.$t('template-component.created'),
                  type: 'success',
                });
                this.$emit('submit');
                this.isSending = false;
                this.$router.push('/mail/templates');
              },
              (error) => {
                this.$toast.show({
                  title: `${this.$t('sms.infos.filters.status.lbl-error')} ${
                    error.code
                  }`,
                  content: error.message,
                  type: 'danger',
                });
                this.isSending = false;
              },
            );
          });
        }, false);
      } else {
        MailService.editTemplate(this.form).then(
          () => {
            this.$toast.show({
              title: this.$t('generic-str.success'),
              content: this.$t('template-component.edited'),
              type: 'success',
            });
            this.$emit('submit');
            this.isSending = false;
          },
          (error) => {
            this.$toast.show({
              title: `${this.$t('sms.infos.filters.status.lbl-error')} ${
                error.code
              }`,
              content: error.message,
              type: 'danger',
            });
            this.isSending = false;
          },
        );
      }
    },
    editLib() {
      this.isSending = true;
      StripoApi.StripoApi.compileEmail((error, html, ampHtml, ampErrors) => {
        this.form.body = html;
        StripoApi.StripoApi.getTemplate((html, css) => {
          this.form.css = css;
          this.form.html = html;
          MailService.editLib(this.form).then(
            () => {
              this.$toast.show({
                title: this.$t('generic-str.success'),
                content: this.$t('template-component.created'),
                type: 'success',
              });
              this.$emit('submit');
              this.isSending = false;
              this.$router.push('/mail/templates');
            },
            (error) => {
              this.$toast.show({
                title: `${this.$t('sms.infos.filters.status.lbl-error')} ${
                  error.code
                }`,
                content: error.message,
                type: 'danger',
              });
              this.isSending = false;
            },
          );
        });
      }, false);
    },
    createLib() {
      this.isSending = true;
      StripoApi.StripoApi.compileEmail((error, html, ampHtml, ampErrors) => {
        this.form.body = html;
        StripoApi.StripoApi.getTemplate((html, css) => {
          this.form.css = css;
          this.form.html = html;
          MailService.createLib(this.form).then(
            () => {
              this.$toast.show({
                title: this.$t('generic-str.success'),
                content: this.$t('template-component.created'),
                type: 'success',
              });
              this.$emit('submit');
              this.isSending = false;
              this.$router.push('/mail/templates');
            },
            (error) => {
              this.$toast.show({
                title: `${this.$t('sms.infos.filters.status.lbl-error')} ${
                  error.code
                }`,
                content: error.message,
                type: 'danger',
              });
              this.isSending = false;
            },
          );
        });
      }, false);
    },
    create() {
      this.isSending = true;
      if (this.typeCode === 'simple') {
        StripoApi.StripoApi.compileEmail((error, html, ampHtml, ampErrors) => {
          this.form.body = html;
          StripoApi.StripoApi.getTemplate((html, css) => {
            this.form.css = css;
            this.form.html = html;
            MailService.createTemplate(this.form).then(
              () => {
                this.$toast.show({
                  title: this.$t('generic-str.success'),
                  content: this.$t('template-component.created'),
                  type: 'success',
                });
                this.$emit('submit');
                this.isSending = false;
                this.$router.push('/mail/templates');
              },
              (error) => {
                this.$toast.show({
                  title: `${this.$t('sms.infos.filters.status.lbl-error')} ${
                    error.code
                  }`,
                  content: error.message,
                  type: 'danger',
                });
                this.isSending = false;
              },
            );
          });
        }, false);
      } else {
        MailService.createTemplate(this.form).then(
          () => {
            this.$toast.show({
              title: this.$t('generic-str.success'),
              content: this.$t('template-component.created'),
              type: 'success',
            });
            this.$emit('submit');
            this.isSending = false;
            this.$router.push('/mail/templates');
          },
          (error) => {
            this.$toast.show({
              title: `${this.$t('sms.infos.filters.status.lbl-error')} ${
                error.code
              }`,
              content: error.message,
              type: 'danger',
            });
            this.isSending = false;
          },
        );
      }
    },
    startPlugin(htmlCode, cssCode) {
      // console.log('startPlugin', 'start', {
      //   apiBaseUrl: process.env.VUE_APP_STRIPO_URL,
      //   pluginId: process.env.VUE_APP_STRIPO_PLUGIN_API,
      //   secretKey: process.env.VUE_APP_STRIPO_SECRET_KEY,
      //   emailId: this.info.id,
      // });
      const api = axiosApi.create({
        baseURL: process.env.VUE_APP_STRIPO_URL,
      });
      // console.log('startPlugin', { api });
      // console.log('startPlugin', { info: this.info });

      this.stripoPlugin = StripoApi.init({
        settingsId: 'stripoSettingsContainer',
        previewId: 'stripoPreviewContainer',
        html: htmlCode,
        css: cssCode,
        onToggleCodeEditor: (codeEditorVisible) => {
          console.log(codeEditorVisible);
          console.log('toggle');
        },
        codeEditorButtonId: 'codeEditorButtonId',
        locale: 'pt',
        apiBaseUrl: process.env.VUE_APP_STRIPO_URL,
        pluginId: process.env.VUE_APP_STRIPO_PLUGIN_API,
        secretKey: process.env.VUE_APP_STRIPO_SECRET_KEY,
        apiRequestData: {
          emailId: this.info.id,
        },
        viewInBrowserLink: 'Yes',
        onTemplateLoaded: (data) => {
          // console.log('startPlugin:Loaded', data);
          console.log('router:id', this.$route.params.id);
          this.isLoading = false;
          this.fetched = true;
        },
        getAuthToken: (callback) => {
          this.isLoading = false;
        },
      });
    },
    mountPreview() {
      if (this.typeCode === 'code') {
        this.$root.$emit('updated.previewmail', {
          body: this.form.body,
        });
      } else if (this.typeCode === 'simple') {
        /* StripoApi.StripoApi.getTemplate((html, css) => {
          console.log(html);
          this.form.body = html;
          this.$root.$emit('updated.previewmail', {
            body: this.form.body,
          });
        }); */
        StripoApi.StripoApi.compileEmail((error, html, ampHtml, ampErrors) => {
          console.log(ampHtml);
          this.form.body = html;
          this.$root.$emit('updated.previewmail', {
            body: this.form.body,
          });
        }, false);
      }
    },
    putEmoji(emoji) {
      if (this.form.subject.length) {
        this.form.subject += ` ${emoji}`;
      } else {
        this.form.subject = emoji;
      }
    },
    changeType(type) {
      console.log(StripoApi.StripoApi);
      this.typeCode = type;
      if (type === 'simple') {
        StripoApi.StripoApi.updateHtmlAndCss(this.form.body);
      } else if (type === 'code') {
        StripoApi.StripoApi.compileEmail((error, html, ampHtml, ampErrors) => {
          this.form.body = html;
        });
      }
    },
    openFileUpload() {
      this.$refs.uploadedFile.click();
    },
    addVar(entity, to) {
      if (to === 'subject') {
        this.addVarsSubject = false;
        this.form.subject = this.form.subject.concat(` {${entity}} `);
      } else {
        this.addVars = false;
        this.form.body = this.form.body.concat(` {${entity}} `);
      }
    },
    showAddVar() {
      this.addVars = true;
    },
    hideAddVar() {
      this.addVars = false;
    },
    request(method, url, data, callback) {
      const req = new XMLHttpRequest();
      req.onreadystatechange = () => {
        if (req.readyState === 4 && req.status === 200) {
          callback(req.responseText);
        } else if (req.readyState === 4 && req.status !== 200) {
          console.error(
            'Can not complete request. Please check you entered a valid PLUGIN_ID and SECRET_KEY values',
          );
        }
      };
      req.open(method, url, true);
      if (method !== 'GET') {
        req.setRequestHeader('content-type', 'application/json');
      }
      req.send(data);
    },
    remove() {
      Swal.fire({
        title: 'Remover template?',
        text: 'Essa ação não poderá ser desfeita',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('generic-str.yes'),
      }).then((result) => {
        if (result.value) {
          if (this.$route.params.isLib === 'true' && this.isLib === true) {
            MailService.deleteLib(this.$route.params.id).then(
              () => {
                this.$modal.hide('dialog'); // Fecha o dialog após a execução do handler.
                this.$toast.show({
                  title: this.$t('generic-str.success'),
                  content: 'Lib excluida',
                  type: 'success',
                });
                this.$router.push('/mail/templates');
              },
              (error) => {
                this.content = error;
              },
            );
          } else {
            MailService.deleteTemplate(this.$route.params.id).then(
              () => {
                this.$modal.hide('dialog'); // Fecha o dialog após a execução do handler.
                this.$toast.show({
                  title: this.$t('generic-str.success'),
                  content: this.$t('template-component.deleted'),
                  type: 'success',
                });
                this.$router.push('/mail/templates');
              },
              (error) => {
                this.content = error;
              },
            );
          }
        }
      });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getTemplate(1);
    } else {
      // ee764232-4a2f-471b-bae0-806e6ce270a6
      MailService.getLibs({ id: 'e0e32091-a8de-4e19-89c9-7260ea5943e9' }).then(
        (response) => {
          this.fetched = true;
          // console.log('before:startPlugin', response?.data);

          const resp = response?.data?.[0];

          if (resp) {
            this.form = resp;
            this.form.type = resp.type ?? '';
            this.form.station = resp.station ?? '';
            this.form.resource = resp.resource ?? '';
            this.form.industry = resp.industry ?? '';

            this.startPlugin(resp.html, resp.css);
          } else {
            this.form = {
              id: 'e0e32091-a8de-4e19-89c9-7260ea5943e9',
              name: 'Demo 1',
              html: BLANK_HTML,
              css: BLANK_HTML,
              preview_url: 'https://web-api.yup.chat/bucket/52867698-ac7b-4186-a7e9-8525161c8b7f/public/email/fe3008f0-9ac3-418e-b782-a0ee6138dcbe',
              preview_id: 'fe3008f0-9ac3-418e-b782-a0ee6138dcbe',
              is_lib: true,
              created_at: '2021-11-08T18:06:06.000000Z',
              updated_at: '2021-11-08T18:06:06.000000Z',
              category: null,
              type: '',
              station: '',
              resource: '',
              industry: '',
            };
            this.startPlugin(BLANK_HTML, BLANK_CSS);
          }
        },
        (error) => {
          this.content = error;
          console.error('before:startPlugin', error);
        },
      );
    }
  },
};
</script>

<style lang="scss">
textarea:not(:last-child) {
  border-bottom: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.textarea-information {
  border: 1px solid #dfe7f3;
  border-top: none;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  padding: 0.2rem 0.5rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
textarea:focus + .textarea-information {
  border: 1px solid #635ebe;
  border-top: none;
}
.input-date {
  margin-top: 15px !important;
}
.form-control.invalid {
  border-color: #ff5c75;
}
.actions-var {
  position: relative !important;
}
.emoji-color {
  color: #a6a6a6 !important;
}
.second-toolbar #logo {
  visibility: hidden;
}
.fr-wrapper > *:first-child {
  display: none;
}
.fr-wrapper .fr-element {
  display: block;
}
.send-group-card {
  box-shadow: none;
}
.send-group-card .table-placeholder i,
h5 {
  color: #b5b5b5;
}
.actions-var-cancel {
  text-align: center;
  color: #4d5a68;
  border-top: 1px solid rgba(234, 243, 253, 0.7);
  padding-top: 5px;
  padding-bottom: 0px;
}
.actions-icon {
  font-size: 14px !important;
}
.actions-var a {
  cursor: pointer;
}
.custom-control-inline-send {
  margin-left: 0px !important;
  padding-left: 0px !important;
}
.label-send-check {
  margin-left: 10px;
  margin-top: 2px;
}
.ul-list-groups {
  margin: 0px;
  padding: 0px;
}
.ul-list-groups li {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
.subjectvar {
  position: absolute !important;
  top: 6px;
  right: 55px;
}
.ti-input {
  border-color: #dfe7f3 !important;
  border: 1px solid #dfe7f3 !important;
  width: 100%;
  border-radius: 0.25rem !important;
}
.vue-tags-input {
  max-width: 100% !important;
  width: 100% !important;
}
#cke_673 {
  display: none !important;
}
.cke_toolbar_last {
  display: none;
}
#externalSystemContainer {
  background-color: darkgrey;
  padding: 5px 0 5px 20px;
}
#undoButton,
#redoButton {
  display: none;
}
#stripoSettingsContainer {
  width: 400px;
  float: left;
  border-right: #e3e3e3 solid 1px;
  border-bottom: #e3e3e3 solid 1px !important;
}
#stripoPreviewContainer {
  width: calc(100% - 400px);
  float: left;
}
.notification-zone {
  position: fixed;
  width: 400px;
  z-index: 99999;
  right: 20px;
  bottom: 80px;
}
.control-button {
  border-radius: 17px;
  padding: 5px 10px;
  border-color: grey;
}
#changeHistoryLink {
  cursor: pointer;
}
.esdev-app .nav-tabs.nav-justified > li {
  width: 50% !important;
}
ol li,
p,
ul li {
  line-height: 1 !important;
}
.live-load {
  text-align: center;
  margin-top: 40px;
}
.live-load .spinner-grow-sm {
  width: 1.5rem;
  height: 1.5rem;
  margin: 10px;
}
.esdev-app .nav-justified > li {
  width: 100% !important;
}
.esdev-app .esdev-option-panel .filter-option > img {
  margin-top: 0px !important;
  height: 80% !important;
}
.filter-option {
  height: 100% !important;
}
.esdev-app .datepicker {
  width: 20% !important;
}
.copy {
  padding: 1em;
  border-bottom: thin solid #e8eef4;

  .unsubscribe-t {
    padding: 0.3em 0.2em 0 0;
  }

  &::after {
    clear: both;
    content: '';
    display: block;
  }

  & > div {
    float: right;
    width: 400px;
  }
}
</style>
